var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanetHomePage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 41.5C83 30.4935 78.6277 19.9378 70.8449 12.1551C63.0622 4.37231 52.5065 8.30967e-07 41.5 0C30.4935 -8.30966e-07 19.9378 4.37231 12.1551 12.1551C4.37231 19.9378 1.66193e-06 30.4935 0 41.5L1.66 41.5C1.66 30.9338 5.85742 20.8003 13.3289 13.3289C20.8003 5.85741 30.9338 1.66 41.5 1.66C52.0662 1.66 62.1997 5.85742 69.6711 13.3289C77.1426 20.8003 81.34 30.9338 81.34 41.5H83Z",
    fill: "url(#paint0_linear_6105_81483)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9997 27.6663C33.6359 27.6663 27.6663 33.6359 27.6663 40.9997C27.6663 48.3635 33.6359 54.333 40.9997 54.333C48.3635 54.333 54.333 48.3635 54.333 40.9997C54.333 33.6359 48.3635 27.6663 40.9997 27.6663ZM24.333 40.9997C24.333 31.7949 31.7949 24.333 40.9997 24.333C50.2044 24.333 57.6663 31.7949 57.6663 40.9997C57.6663 50.2044 50.2044 57.6663 40.9997 57.6663C31.7949 57.6663 24.333 50.2044 24.333 40.9997Z",
    fill: "url(#paint1_linear_6105_81483)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3395 40.4407C40.89 40.1337 41.5252 40.0132 42.1499 40.0974L41.9441 41.6238L42.1499 40.0974L45.7153 40.5781L45.4926 42.2298L45.7153 40.5781C46.1189 40.6325 46.5067 40.7708 46.8536 40.9842C46.8536 40.9842 46.8537 40.9842 46.8537 40.9842L55.3359 46.2011C56.1199 46.6834 56.3646 47.7099 55.8824 48.4939C55.4002 49.278 54.3736 49.5227 53.5896 49.0404L45.1825 43.8697L42.0138 43.4426L40.1122 47.7096L42.8632 50.6853C43.174 51.0213 43.4012 51.4258 43.5266 51.8661C43.6521 52.3063 43.6721 52.7698 43.5852 53.2192L42.9868 56.3124C42.812 57.2161 41.9377 57.807 41.034 57.6322C40.1303 57.4573 39.5394 56.583 39.7142 55.6793L40.2725 52.7932L37.4782 49.7708L38.6491 48.6882L37.4782 49.7708C37.0908 49.3519 36.8349 48.8285 36.742 48.2655C36.6492 47.7025 36.7235 47.1247 36.9557 46.6036C36.9557 46.6036 36.9557 46.6035 36.9557 46.6035L39.0961 41.8007L40.6185 42.4791L39.0961 41.8007C39.3527 41.2249 39.789 40.7478 40.3395 40.4407ZM40.4157 52.9481C40.4155 52.948 40.4154 52.9478 40.4153 52.9477Z",
    fill: "url(#paint2_linear_6105_81483)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7974 28.1535C32.6452 28.5121 33.0418 29.49 32.6833 30.3378L31.3505 33.4894L33.0077 37.9125L36.1334 38.5843C36.567 38.6775 36.9736 38.8683 37.3223 39.1422C37.671 39.4161 37.9526 39.766 38.1458 40.1651L38.1458 40.1651L38.6267 41.1584H40.4643C41.3847 41.1584 42.1309 41.9046 42.1309 42.8251C42.1309 43.7455 41.3847 44.4917 40.4643 44.4917H38.3654C37.8174 44.4917 37.2805 44.3373 36.8162 44.0462C36.3518 43.7551 35.9789 43.3391 35.7402 42.8458L37.2105 42.1341L35.7402 42.8458L35.2342 41.8005L32.0846 41.1236C31.6065 41.0208 31.162 40.7995 30.7919 40.4801C30.4217 40.1606 30.1378 39.7532 29.9662 39.2954L28.1708 34.5035C27.9089 33.8044 27.9249 33.0316 28.2157 32.3441L29.6132 29.0394C29.9718 28.1916 30.9497 27.795 31.7974 28.1535Z",
    fill: "url(#paint3_linear_6105_81483)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0088 25.0359C44.8126 24.5872 45.8278 24.875 46.2765 25.6787L47.7349 28.291C48.0566 28.8672 48.1734 29.5355 48.0662 30.1866C47.9589 30.8378 47.6341 31.4333 47.1446 31.876L42.9398 35.6787L42.9398 35.6787C42.7733 35.8293 42.5899 35.9602 42.3934 36.0687L42.3934 36.0687L40.4806 37.125C40.0489 37.3634 39.5638 37.4885 39.0706 37.4885H36.012L34.8183 40.3224C34.461 41.1706 33.4836 41.5686 32.6353 41.2113C31.787 40.854 31.389 39.8766 31.7464 39.0284L33.0475 35.9395C33.2703 35.4107 33.6442 34.9593 34.1223 34.6419C34.6004 34.3244 35.1615 34.1551 35.7354 34.1551H38.9632L40.7397 33.1741L44.6627 29.6262L43.366 27.3036C42.9174 26.4999 43.2051 25.4846 44.0088 25.0359Z",
    fill: "url(#paint4_linear_6105_81483)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6105_81483",
    x1: 0,
    y1: 41.5,
    x2: 83,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6105_81483",
    x1: 24.333,
    y1: 40.9997,
    x2: 57.6663,
    y2: 40.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6105_81483",
    x1: 36.7031,
    y1: 48.867,
    x2: 56.1296,
    y2: 48.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6105_81483",
    x1: 27.9854,
    y1: 36.2566,
    x2: 42.1309,
    y2: 36.2566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6105_81483",
    x1: 31.6152,
    y1: 33.0833,
    x2: 48.1049,
    y2: 33.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetHomePage);
export default __webpack_public_path__ + "static/media/planetHomePage.8c175e4b.svg";
export { ForwardRef as ReactComponent };